require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-forests-and-the-world-bank-whats-the-score.json") })
        }
      }, "path---en-us-update-forests-and-the-world-bank-whats-the-score");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-forests-and-the-world-bank-whats-the-score!./.cache/json/en-us-update-forests-and-the-world-bank-whats-the-score.json
// module id = 666
// module chunks = 231608221292675